import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import "./ProductMembershipInfoPage.scss";
import RecruitmentQuestionMembership from "./RecruitmentQuestionMembership";

const ProductMembershipInfoPage = () => {
  const membershipId = useParams().id;
  return (
    <div className="product-membership-info-wrapper">
      {membershipId === "1" && <RecruitmentQuestionMembership />}
    </div>
  );
};

export default ProductMembershipInfoPage;
